import { setPublicPath } from '@pipltrust/apps-components';
setPublicPath({ path: process.env.WEBPACK_INNER_PUBLIC_PATH || '' });
import React, { useRef } from 'react';
import ReactDOM from 'react-dom';
import { Header } from '@pipltrust/apps-components';
import { useCookies } from 'react-cookie/es6';
import Content from './dpa_components/content';
import styles from './dpa_components/dpa.module.less';

const root = document.getElementById('root');
window.__CONFIG__ = window.__CONFIG__ || { GA_TRACKING_ID: '' };
const dpaStatus = window.__INITIAL_STATE?.display_sign_dpa_type || 'did_not_sign';
const acceptDate = window.__INITIAL_STATE?.dpa_accept_date || '';
const dpaLastUpdate = window.__INITIAL_STATE?.dpa_last_update || '';
const user = window.__INITIAL_STATE?.user || {};
const helpLink = window.__INITIAL_STATE?.help_link || '';
const logoutUrl = window.__INITIAL_STATE?.logout_url || '/';
const apiUsageUrl = window.__CONFIG__?.API_USAGE_URL;
const enrichedUser = { ...user, name: `${user.first_name} ${user.last_name}` };

const handleLogout = () => {
  window.location.href = logoutUrl;
};

function App() {
  const componentRef = useRef(null);
  const [cookies] = useCookies([]);
  const csrfToken = cookies[window.__CONFIG__?.CSRF_COOKIE_NAME];
  window.__CONFIG__ = window.__CONFIG__ || { GA_TRACKING_ID: '' };

  return (
    <div className={styles.container}>
      <Header
        user={enrichedUser}
        onSignOut={handleLogout}
        helpLink={helpLink}
        hasSideMenu={false}
        isSignedIn
        csrfToken={csrfToken}
        contextApp="accounts"
        switchAppLink={apiUsageUrl}
        eventTrackingFunction={() => {}}
      />
      <Content
        user={user}
        dpaStatus={dpaStatus}
        acceptDate={acceptDate}
        dpaLastUpdate={dpaLastUpdate}
        ref={componentRef}
      />
    </div>
  );
}

ReactDOM.render(<App />, root);
